import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  FormFeedback,
  Modal,
  Button,
} from "reactstrap"

import Select from "react-select"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import { Link, useHistory, useParams, useLocation } from "react-router-dom"

// import images
import logo from "assets/images/logo-large.png"

import "../../../assets/scss/custom/style.css"

import Autocomplete from "@material-ui/lab/Autocomplete"
import Box from "@material-ui/core/Box"
import { TextField } from "@material-ui/core"
import Snackbars from "../../../Utils/Snackbars"
import useRequestsWOAccessToken from "../../../Utils/useRequestsWOAccessToken"
import i18next from "i18next"

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? "#036B41"
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? "#fff"
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Register = props => {
  //meta title
  document.title = i18next.t("Register PG document title")
  const history = useHistory()
  const { getRequestWOAccessToken, postRequestWOAccessToken } =
    useRequestsWOAccessToken()
  const { referral_code } = useParams()
  const location = useLocation()

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const [formData1, setFormData1] = React.useState({
    country: { label: "Spain", value: "Spain" },
    country_code: { id: 212, title: "ES +34", code: "ES", value: 34 },
  })
  const [CustomError1, setCustomError1] = React.useState({
    country: "",
    country_code: "",
  })
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      referral_code: "",
      phone: "",
      password: "",
      confirm_password: "",
      mailchimp: false,
      dob: null,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required(
        i18next.t("Register PG First Name is required"),
      ),
      last_name: Yup.string().required(
        i18next.t("Register PG Last Name is required"),
      ),
      dob: Yup.date()
        .nullable()
        .required(i18next.t("Register PG Date of Birth is required")),

      email: Yup.string()
        .email(i18next.t("Please enter a valid email!"))
        .max(255)
        .required(i18next.t("Register PG Email is required")),
      phone: Yup.string()
        .matches(
          /^[#0-9]+$/,
          i18next.t("Please enter a valid register pg mobile number!"),
        )
        .required(i18next.t("Register PG Mobile Number is required"))
        .test(
          "len",
          i18next.t(
            "Register PG Mobile numbers should not be greater than 10 digits!",
          ),
          function (value) {
            return value ? value.length <= 10 : false // Ensure the number is not greater than 10 digits
          },
        ),
      password: Yup.string()
        .matches(
          /[A-Z]/,
          i18next.t(
            "Register PG Password must contain at least one uppercase letter",
          ),
        )
        .matches(
          /[a-z]/,
          i18next.t(
            "Register PG Password must contain at least one lowercase letter",
          ),
        )
        .matches(
          /\d/,
          i18next.t(
            "Register PG Password must contain at least one numeric character",
          ),
        )
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          i18next.t(
            "Register PG Password must contain at least one special character",
          ),
        )
        .required(i18next.t("Register PG Password is required"))
        .min(8, i18next.t("Register PG Password must be at least 8 characters"))
        .max(
          20,
          i18next.t("Register PG Password must be at most 20 characters"),
        ),
      confirm_password: Yup.string()
        .oneOf(
          [Yup.ref("password"), null],
          i18next.t("Register PG Both passwords need to be the same!"),
        )
        .required(i18next.t("Register PG Confirm Password is required")),
      // mailchimp: Yup.boolean()
      // .oneOf([true], i18next.t('You must accept the mailchimp subscription to continue!'))
    }),
    onSubmit: async values => {
      try {
        setCustomError1({
          ...CustomError1,
          country: "",
          country_code: "",
        })

        if (formData1.country === null) {
          setCustomError1({
            ...CustomError1,
            country: i18next.t("Register PG Please select country"),
          })
        } else if (formData1.country_code === null) {
          setCustomError1({
            ...CustomError1,
            country_code: i18next.t("Register PG Please select country code"),
          })
        } else {
          let submit1 = document.getElementById("submit1")
          submit1.disabled = true
          submit1.textContent = i18next.t("Processing...")

          const additionalData = {}
          if (values.mailchimp == true) {
            additionalData.mailchimp = values.mailchimp
          }
          const jsonpar = JSON.stringify({
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            referral_code: values.referral_code,
            collaborator_referral_code: "",
            country: formData1.country.value,
            country_code: formData1.country_code.value,
            phone: values.phone,
            password: values.password,
            confirm_password: values.confirm_password,
            preferred_language: PreferredLanguage,
            dob: values.dob,
            ...additionalData,
          })
          const res = await postRequestWOAccessToken("signup", jsonpar)
          if (res && res.code === 200) {
            let originalText = res.data

            history.push("/email-mobile-verification", {
              id: originalText,
              email: values.email,
              country_code: formData1.country_code.value,
              phone: values.phone,
              code: 200,
              status: "success",
              message: res.message,
            })
          } else {
            setAlertData(AlertData => ({
              ...AlertData,
              variant: "error",
              message: res.message,
            }))
          }
          resetAlertData()

          submit1.disabled = false
          submit1.textContent = i18next.t("Register")
        }
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([])
  const [AllCountriesCustomData2, setAllCountriesCustomData2] = React.useState(
    [],
  )
  const handleLoadGetAllCountries = async phone_code => {
    const res = await getRequestWOAccessToken("get-all-countries")
    if (res && res.code === 200) {
      let originalText = res.data

      // Country dropdown (names)
      let countryOptions = originalText.map(element => ({
        label: element.country_name,
        value: element.country_name,
      }))

      setAllCountriesCustomData2([{ options: countryOptions }])

      // Country code dropdown (phone codes)
      let phoneOptions = originalText.map(element => ({
        id: element.id,
        title: element.country_code + " +" + element.phone_code,
        code: element.country_code,
        value: element.phone_code,
        country_name: element.country_name,
      }))

      setAllCountriesCustomData(phoneOptions)

      // ✅ Find default country using phone_code
      const matchedCountry = phoneOptions.find(
        el => String(el.value) === String(phone_code),
      )
      if (matchedCountry) {
        setFormData1({
          country: {
            label: matchedCountry.country_name,
            value: matchedCountry.country_name,
          },
          country_code: matchedCountry,
        })
      }
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }
  const [PreferredLanguage, setPreferredLanguage] = React.useState("eng")
  const onChangePreferredLanguage = e => {
    i18next.changeLanguage(e.target.value)
    setPreferredLanguage(e.target.value)
    localStorage.setItem("I18N_LANGUAGE", e.target.value)
  }

  const [UID, setUID] = React.useState(0)
  const [Email, setEmail] = React.useState("")
  const [CountryCode, SetCountryCode] = React.useState("")
  const [Phone, setPhone] = React.useState("")
  React.useEffect(() => {
    const language = localStorage.getItem("I18N_LANGUAGE")
    if (!language) setPreferredLanguage("sp")
    else setPreferredLanguage(language)

    if (referral_code) {
      validation1.setValues({
        ...validation1.values,
        referral_code: referral_code,
      })
    }

    if (
      typeof location.state !== "undefined" &&
      typeof location.state.message !== "undefined"
    ) {
      handleLoadGetAllCountries(location.state.country_code)
      setUID(location.state.id)
      setEmail(location.state.email)
      SetCountryCode(location.state.country_code)
      setPhone(location.state.phone)
      setAlertData(AlertData => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }))
      resetAlertData()
    }
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="p-0 container-fluid">
        <select
          className="form-select top-right-lang"
          name="preferred_language"
          value={PreferredLanguage}
          onChange={e => onChangePreferredLanguage(e)}
        >
          <option value={"eng"}>English</option>
          <option value={"sp"}>Spanish</option>
        </select>
        <Row className="g-0">
          <Col className="LeftImg">
            <div className="auth-full-page-content p-3 bg-white">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="auth-logo-light">
                      <div className="mb-1">
                        <span className="">
                          {" "}
                          <img src={logo} alt="" height="60" />{" "}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="my-auto">
                    <div className="">
                      <h5 className="text-black mb-3">
                        {i18next.t("Nationality")}
                      </h5>
                    </div>
                    <div className="mt-4">
                      <div className="p-2">
                        <div className="form-horizontal">
                          <div className="row">
                            <Col md={12}>
                              <div className="mb-3 Register-Select2">
                                <Label className="form-label">
                                  {i18next.t("Select Nationality")} :
                                </Label>
                                <Select
                                  styles={colourStyles}
                                  value={formData1.country}
                                  onChange={e =>
                                    setFormData1({ ...formData1, country: e })
                                  }
                                  options={AllCountriesCustomData2}
                                  classNamePrefix="select2-selection"
                                />
                                {CustomError1.country !== "" ? (
                                  <FormFeedback
                                    type="invalid"
                                    style={{ display: "block" }}
                                  >
                                    {CustomError1.country}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </div>

                          <div className="mt-4 d-grid">
                            <Button
                              id="submit1"
                              onClick={e => {
                                history.push("/tax")
                              }}
                              data-toggle="modal"
                              data-target="#myModal"
                              className="btn btn-primary btn-block"
                            >
                              {" "}
                              {i18next.t("Continue")}{" "}
                            </Button>
                          </div>
                        </div>
                        <div className="mt-3 text-center">
                          <p className="mb-0"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="footer-text-color">
                      {" "}
                      © {new Date().getFullYear()} Tokenized Green.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="rightImg">
            <div className="bgLogin"></div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default Register
